import request from '@/utils/request';

// 添加日志功能
const apiLog = (api, params = null) => {
  console.log(`调用API: ${api}`, params ? `, 参数: ${JSON.stringify(params)}` : '');
};

/**
 * 获取聊天联系人列表
 * @returns {Promise} 返回联系人列表的Promise对象
 */
export function getContactsList() {
  apiLog('getContactsList');
  
  // API文档中的URL是 /api/v1/messages/contacts
  return request({
    url: '/api/v1/messages/contacts',
    method: 'get'
  }).catch(error => {
    console.error('获取联系人列表失败，尝试备用URL', error);
    
    // 尝试备用URL格式
    return request({
      url: '/messages/contacts',
      method: 'get'
    });
  });
}

/**
 * 获取聊天消息列表
 * @param {Object} params 参数对象
 * @param {number} params.contact_id 联系人ID
 * @param {number} [params.skip] 分页起始位置，默认0
 * @param {number} [params.limit] 每页数量，默认20
 * @returns {Promise} 返回消息列表的Promise对象
 */
export function getMessagesList(params) {
  apiLog('getMessagesList', params);
  
  return request({
    url: '/api/v1/messages/list',
    method: 'get',
    params
  }).catch(error => {
    console.error('获取消息列表失败，尝试备用URL', error);
    
    // 尝试备用URL格式
    return request({
      url: '/messages/list',
      method: 'get',
      params
    });
  });
}

/**
 * 发送聊天消息
 * @param {Object} data 请求数据
 * @param {number} data.receiver_id 接收者ID
 * @param {string} data.content 消息内容
 * @returns {Promise} 返回发送结果的Promise对象
 */
export function sendMessage(data) {
  apiLog('sendMessage', data);
  
  return request({
    url: '/api/v1/messages/send',
    method: 'post',
    data
  }).catch(error => {
    console.error('发送消息失败，尝试备用URL', error);
    
    // 尝试备用URL格式
    return request({
      url: '/messages/send',
      method: 'post',
      data
    });
  });
}

/**
 * 标记消息为已读
 * @param {Object} data 请求数据
 * @param {number[]} data.message_ids 消息ID列表
 * @returns {Promise} 返回标记结果的Promise对象
 */
export function markMessagesRead(data) {
  return request({
    url: '/api/v1/messages/read',
    method: 'put',
    data
  });
}

/**
 * 获取未读消息数量
 * @returns {Promise} 返回未读消息数量的Promise对象
 */
export function getUnreadCount() {
  return request({
    url: '/api/v1/messages/unread-count',
    method: 'get'
  });
}

/**
 * 删除聊天消息
 * @param {number} messageId 消息ID
 * @returns {Promise} 返回删除结果的Promise对象
 */
export function deleteMessage(messageId) {
  return request({
    url: `/api/v1/messages/${messageId}`,
    method: 'delete'
  });
}

/**
 * 获取家长孩子所在班级的所有教师
 * @param {Object} params - 查询参数，包含campus_code
 * @returns {Promise} 返回教师列表的Promise对象
 */
export function getParentTeacherContacts(params = {}) {
  console.log('调用getParentTeacherContacts API函数');
  const url = '/api/v1/messages/parent/teacher-contacts';
  console.log('API路径:', url);
  
  // 获取当前用户的校区信息
  let campusCode = '';
  try {
    if (params && params.campus_code) {
      campusCode = params.campus_code;
    } else if (localStorage.getItem('campusCode')) {
      campusCode = localStorage.getItem('campusCode');
    } else if (localStorage.getItem('currentCampus')) {
      const campusInfo = JSON.parse(localStorage.getItem('currentCampus'));
      campusCode = campusInfo.code || '';
    }
  } catch (e) {
    console.error('获取用户校区信息失败:', e);
  }
  
  // 合并参数
  const queryParams = {
    ...(params || {}),
    campus_code: campusCode || params.campus_code || ''
  };
  
  console.log('查询参数:', queryParams);
  
  return request({
    url,
    method: 'get',
    params: queryParams
  });
}

/**
 * 获取教师负责班级的所有家长
 * @param {Object} params - 查询参数，包含campus_code
 * @returns {Promise} 返回家长列表的Promise对象
 */
export function getTeacherParentContacts(params = {}) {
  console.log('调用getTeacherParentContacts API函数');
  const url = '/api/v1/messages/teacher/parent-contacts';
  console.log('API路径:', url);
  
  // 获取当前用户的校区信息
  let campusCode = '';
  try {
    if (params && params.campus_code) {
      campusCode = params.campus_code;
    } else if (localStorage.getItem('campusCode')) {
      campusCode = localStorage.getItem('campusCode');
    } else if (localStorage.getItem('currentCampus')) {
      const campusInfo = JSON.parse(localStorage.getItem('currentCampus'));
      campusCode = campusInfo.code || '';
    }
  } catch (e) {
    console.error('获取用户校区信息失败:', e);
  }
  
  // 合并参数
  const queryParams = {
    ...(params || {}),
    campus_code: campusCode || params.campus_code || ''
  };
  
  console.log('查询参数:', queryParams);
  
  return request({
    url,
    method: 'get',
    params: queryParams
  });
} 